import { EventEmitter, QueryList, AfterContentInit } from '@angular/core';
import { AngularWizardStepComponent } from './wizard-step.component';
var AngularWizardComponent = /** @class */ (function () {
    function AngularWizardComponent() {
        this._steps = [];
        this._isCompleted = false;
        this.onStepChanged = new EventEmitter();
    }
    AngularWizardComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        var tempSteps;
        this.wizardSteps.forEach(function (step) { return _this._steps.push(step); });
        this.wizardSteps.changes.subscribe(function (wizardStepsNew) {
            tempSteps = [];
            wizardStepsNew.forEach(function (newStep) {
                tempSteps.push(newStep);
            });
            _this.steps = tempSteps;
            _this.steps[0].isActive = true;
        });
        this.steps[0].isActive = true;
    };
    Object.defineProperty(AngularWizardComponent.prototype, "steps", {
        get: function () {
            return this._steps.filter(function (step) { return !step.hidden; });
        },
        set: function (stp) {
            this._steps = stp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AngularWizardComponent.prototype, "isCompleted", {
        get: function () {
            return this._isCompleted;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AngularWizardComponent.prototype, "activeStep", {
        get: function () {
            return this.steps.find(function (step) { return step.isActive; });
        },
        set: function (step) {
            if (step !== this.activeStep && !step.isDisabled) {
                this.activeStep.isActive = false;
                step.isActive = true;
                this.onStepChanged.emit(step);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AngularWizardComponent.prototype, "activeStepIndex", {
        get: function () {
            return this.steps.indexOf(this.activeStep);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AngularWizardComponent.prototype, "hasNextStep", {
        get: function () {
            return this.activeStepIndex < this.steps.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AngularWizardComponent.prototype, "hasPrevStep", {
        get: function () {
            return this.activeStepIndex > 0;
        },
        enumerable: true,
        configurable: true
    });
    AngularWizardComponent.prototype.goToStep = function (step) {
        if (!this.isCompleted) {
            this.activeStep = step;
        }
    };
    AngularWizardComponent.prototype.next = function () {
        if (this.hasNextStep) {
            var nextStep = this.steps[this.activeStepIndex + 1];
            this.activeStep.onNext.emit();
            nextStep.isDisabled = false;
            this.activeStep = nextStep;
        }
    };
    AngularWizardComponent.prototype.previous = function () {
        if (this.hasPrevStep) {
            var prevStep = this.steps[this.activeStepIndex - 1];
            this.activeStep.onPrev.emit();
            prevStep.isDisabled = false;
            this.activeStep = prevStep;
        }
    };
    AngularWizardComponent.prototype.complete = function () {
        this.activeStep.onComplete.emit();
        this._isCompleted = true;
    };
    return AngularWizardComponent;
}());
export { AngularWizardComponent };
